import { DefinedDefaults } from "@/ui/lib";
import { TextareaHTMLAttributes } from "react";

/*-------------------------------------
|  Types
|-------------------------------------*/

export type TTextareaFieldProps = {
  error?: string;
} & TextareaHTMLAttributes<HTMLTextAreaElement>;

export type TTextareaProps = {
  label: string;
} & TTextareaFieldProps;

type TTextareaDefaultProps = DefinedDefaults<
  TTextareaProps,
  "rows"
>;

/*-------------------------------------
|  Defaults
|-------------------------------------*/

export const TEXTAREA_DEFAULTS = {
  rows: 3,
} satisfies TTextareaDefaultProps;
